import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// 스타일드 컴포넌트 정의
const SectionContainer = styled(Box)(({ theme }) => ({
    width: '100%',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
        padding: 0,
    },
}));

const ImageSection = styled(Box)<{ isPadded?: boolean; isFirstOrLast?: boolean; isBanner?: boolean }>(
    ({ isPadded = false, isFirstOrLast = false, isBanner = false }) => ({
        width: isBanner ? '100%' : '80%',
        maxWidth: isBanner ? 'none' : '1200px',
        margin: '0 auto',
        position: 'relative',
        padding: isPadded ? '0 5%' : 0,
        paddingBottom: isFirstOrLast ? '5%' : 0,
        '& img': {
            width: '100%',
            height: isBanner ? '60vh' : 'auto',
            objectFit: isBanner ? 'cover' : 'contain',
            objectPosition: isBanner ? 'center 40%' : 'center center',
            display: 'block',
        },
    }),
);

// AI 피팅 섹션
const AiFittingSection = () => {
    const processes = [
        {
            image: '/images/process/banner.jpg',
            title: '배너 이미지',
            isBanner: true,
        },
        {
            image: '/images/process/description.png',
            title: '총알 피팅 서비스 설명',
        },
        {
            image: '/images/process/description2.png',
            title: '휴먼보다 더 휴먼스러운 AI 설명',
        },
        {
            image: '/images/process/site.png',
            title: '홈페이지 제공 설명',
        },
        {
            image: '/images/process/b2c.png',
            title: 'B2C 홈페이지 설명',
        },
    ];

    return (
        <SectionContainer>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                }}
            >
                {processes.map((process, index) => (
                    <ImageSection
                        key={index}
                        isPadded={!process.isBanner}
                        isFirstOrLast={index === 0 || index === processes.length - 1}
                        isBanner={process.isBanner}
                        sx={{
                            marginBottom: process.isBanner ? '0' : { xs: '2rem', md: '10rem' },
                        }}
                    >
                        <img src={process.image} alt={process.title} />
                    </ImageSection>
                ))}
            </Box>
        </SectionContainer>
    );
};

// 서비스 플랜 섹션
export const ServicePlanSection = () => {
    const servicePlans = [
        // 여기에 서비스 플랜 관련 이미지들을 추가하세요
        {
            image: '/images/process/plan1.png',
        },
        {
            image: '/images/process/plan2.png',
        },
        {
            image: '/images/process/plan3.png',
        },
        // 추가 이미지들...
    ];

    return (
        <SectionContainer>
            <Box
                sx={{
                    marginTop: '100px',
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                }}
            >
                {servicePlans.map((plan, index) => (
                    <ImageSection isPadded isFirstOrLast>
                        <img src={plan.image} />
                    </ImageSection>
                ))}
            </Box>
        </SectionContainer>
    );
};

interface MainPageProps {
    currentSection: 'ai-fitting' | 'service-plan';
}

const MainPage = ({ currentSection }: MainPageProps) => {
    return (
        <Box sx={{ width: '100%', bgcolor: '#fff' }}>
            {currentSection === 'ai-fitting' ? <AiFittingSection /> : <ServicePlanSection />}
        </Box>
    );
};

export default MainPage;
